import React from 'react';

import { RangeContainer } from './rangeContainer';

const SurveyRating = ({
  defaultValues,
  setQuestionArray,
  questionArray,
  question,
}) => {
  return (
    <div>
      {defaultValues.map((field, index) => (
        <RangeContainer
          key={index}
          question={question}
          position={index}
          name={`ratings`}
          option={field?.option}
          label={{ ...field?.label }}
          value={{ ...field?.value }}
          questionArray={questionArray}
          SurveyOption={field?.SurveyOption}
          setQuestionArray={setQuestionArray}
        />
      ))}
    </div>
  );
};

export default SurveyRating;
